module.exports = __webpack_public_path__ + "static/media/declined-icon.02273082.svg";